import { Link } from "react-router-dom"
import { useAuth } from "../../../providers/AuthProvider";

export const UnAuthorised = () => {
    let auth = useAuth();

    const signOut = () => {
        auth?.logout();
    }

    return (
        <div className="authentication-wrapper authentication-2 ui-bg-cover ui-bg-overlay-container px-4">
            <div className="ui-bg-overlay bg-dark opacity-25"></div>
            <div className="authentication-inner py-5">
                <div className="p-5 text-center k-my-24">
                    <p><b>Not a member?&nbsp;<Link className="my-link" to="https://www.bma.org.uk/about-us/contact-us/get-in-touch/contact-us">Sign up for BMA membership</Link></b>&nbsp;using GP Diary.</p>
                </div>
            </div>
        </div>
    )
}